export default "/images/d52c2c9cf815bcb08230fab83aa1b45e.jpg";